import React, { memo } from "react";
import Lightbox from "react-awesome-lightbox";

function OpenImage({ showImage, setShowImage, messages }) {
  return (
    <Lightbox
      onClose={() => setShowImage(false)}
      images={messages}
      startIndex={messages?.findIndex((url) => url == showImage)}
    />
  );
}

export default memo(OpenImage);
